import React, {Component} from 'react';
import Utils from "../Utils";

export default class Text extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: Utils.GetHtmlID(),
        };
    }
    getType() {
        if (this.props.type)
            return this.props.type;
        return 'text';
    }
    getReadOnly() {
        if (this.props.isReadOnly)
            return this.props.isReadOnly;
        return false;
    }
    render() {
        return <div>
            <label htmlFor={this.state.id}>{this.props.title}</label>
            {this.getReadOnly() ?
                <span>{this.props.value}</span>
                :
                <input id={this.state.id}
                       type={this.getType()}
                       value={this.props.value}
                       onChange={e => this.props.onChange(e.target.value)}/>
            }
        </div>
    }
}
